import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import { Media } from '@g4/boneyard/lib/Media';

import { Input, baseStyles } from '../Boneyard/Input/Input';

import calendarInactive from '../../images/icon-45-calendar-deselected.svg';
import calendarActive from '../../images/icon-45-calendar-selected.svg';
import calendarDisabled from '../../images/icon-45-calendar-disabled.svg';

const HiddenInput = styled(Input)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  z-index: 1;
  ${props =>
    !props.disabled &&
    css`
      cursor: pointer;
    `}

  /* Allows the field to be full height on iOS, which otherwise renders a native widget */
  appearance: none;
`;

const Label = styled.div`
  ${baseStyles}

  display: flex;
  align-items: center;

  ${props =>
    props.active &&
    css`
      border: solid 2px ${props.theme.colors.hob.datePicker.activeBorder};
    `}

  ${props => props.theme.query.md} {
    border: inherit;
  }
  ${props =>
    !props.value &&
    css`
      color: ${props => props.theme.colors.hob.input.placeholder};
    `}
`;

const InputMask = ({
  disabled,
  automationHook,
  placeholder,
  value,
  active,
  onClick,
  name,
  className,
}) => (
  <Media>
    {mq => {
      const image = mq.gte('md')
        ? {
            src: !disabled
              ? active
                ? calendarActive
                : calendarInactive
              : calendarDisabled,
            width: 35,
            height: 35,
          }
        : undefined;

      return (
        <div className={className}>
          <HiddenInput
            type="button"
            name={name}
            value={value}
            onClick={onClick}
            disabled={disabled}
            automationHook={automationHook}
            placeholder={placeholder}
          />
          <Label
            aria-hidden
            placeholder={placeholder}
            active={active}
            disabled={disabled}
            image={image}
            value={value}
          >
            {value ? value : placeholder}
          </Label>
        </div>
      );
    }}
  </Media>
);

InputMask.propTypes = {
  automationHook: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  onClick: PropTypes.func,
  placeholder: PropTypes.string,
  active: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

InputMask.defaultTypes = {
  disabled: false,
  value: '',
  onClick: Function.prototype,
};

export default styled(InputMask)`
  position: relative;
  height: 50px;
  ${/* sc-selector */ Label} {
    box-shadow: ${props =>
      props.active
        ? `0 0 0 3px ${props.theme.colors.hob.input.focused}`
        : 'none'};
  }
  &:hover
    ${/* sc-selector */ Label},
    ${/* sc-selector */ HiddenInput}:focus
    + ${/* sc-selector */ Label} {
    box-shadow: ${props =>
      props.disabled
        ? 'none'
        : `0 0 0 3px ${props.theme.colors.hob.input.focused}`};
  }
`;
